
import { connect } from 'react-redux';

import Terms from './../../components/terms/terms';

// import { fetchLatestTabs } from './../../actions/homeActions';

const mapStateToProps = state => {
  return {
    // latestTabs: state.home.get('latestTabs')
  };
};

const mapDispatchProps = dispatch => {
  return {
    // fetchLatestTabs: () => {
    //   dispatch(fetchLatestTabs());
    // }
  }
};

const TermsView = connect(mapStateToProps, mapDispatchProps)(Terms);

export default TermsView;



// WEBPACK FOOTER //
// ./src/views/termsView/termsView.js